const calculators = {
  title: "Rechner",
  open: "Öffnen",
  openCalculator: "{{name}} öffnen",
  seizableIncome: {
    title: "Pfändungsrechner",
    subtitle: "Lohnpfändung · Existenzminimum",
    description:
      "Berechnen Sie den pfändbaren Betrag des Einkommens. Die Grundwerte werden jährlich vom Justizministerium angepasst und können für vergangene Jahre herangezogen werden.",
    inputsTitle: "Eingaben",
    calculationTitle: "Berechnung",
    fields: {
      period: "Periode (Stichtag)",
      periodOption: "{{from}} – {{to}}",
      executionType: "Exekutionsart",
      monthlyIncome: "Einkommen (netto)",
      hasSpecialPayments: "Sonderzahlungen?",
      hasSpecialPaymentsHint: "14 Bezüge/Jahr (12 + Urlaubs- und Weihnachtsgeld)",
      maintenanceObligationCount: "Unterhaltspflichten",
      maintenanceSeizureCount: "Unterhaltspflichten für § 291b",
    },
    executionTypes: {
      standard: "Einfache Lohnexekution",
      maintenance: "Unterhaltsexekution",
    },
    result: {
      income: "Einkommen",
      seizable: "Pfändung",
      seizable291a: "§ 291a",
      seizable291b: "§ 291b",
      retained: "verbleiben",
      baseAmountWithSpecialPayments: "Grundbetrag {{amount}} (mit SZ)",
      baseAmountWithoutSpecialPayments: "Grundbetrag {{amount}} (ohne SZ)",
      maxAssessment: "Höchstbemessung {{amount}}",
      empty: "Geben Sie ein Einkommen ein und wählen Sie eine Periode, um die Berechnung zu sehen.",
      unavailable: "Für die gewählte Periode sind keine Berechnungsparameter hinterlegt.",
    },
    validation: {
      monthlyIncomeNegative: "Das Einkommen darf nicht negativ sein.",
      maintenanceCountMax: "Es sind maximal {{max}} Unterhaltspflichten möglich.",
      seizureCountExceedsObligations:
        "Die Anzahl der gepfändeten Unterhaltspflichten darf die Gesamtanzahl nicht überschreiten.",
    },
    close: "Schließen",
  },
  spousalMaintenance: {
    title: "Unterhaltsrechner",
    subtitle: "Gattenunterhalt",
    description:
      "Prüft anhand einiger Fragen, ob ein Unterhaltsanspruch gegenüber dem:der Ehepartner:in besteht. Die Fragen und die Berechnung entsprechen dem Rechner im Kundenportal.",
    inputsTitle: "Eingaben",
    calculationTitle: "Berechnung",
    result: {
      empty: "Beantworten Sie die Fragen, um die Berechnung zu sehen.",
    },
    close: "Schließen",
  },
  appointmentTargets: {
    title: "1B/EG-Rechner",
    subtitle: "Terminvorgabe 1B & EG · pro Monat",
    description:
      "Berechnet die monatliche Vorgabe an 1B- und EG-Terminen aus Arbeitsmodell, Wochenstunden und geplanten Fehltagen.",
    inputsTitle: "Eingaben",
    calculationTitle: "Berechnung",
    fields: {
      workModel: "Arbeitsmodell",
      weeklyHours: "Meine Wochenstunden",
      weeklyHoursUnit: "Std. / Woche",
      month: "Monat",
      monthManual: "— manuell eingeben —",
      monthOption: "{{month}} · {{days}} Tage",
      calendarWorkdays: "Anzahl der Arbeitstage laut Kalender",
      calendarWorkdaysUnit: "Tage",
      vacationDays: "Geplante Urlaubstage",
      trainingDays: "Geplante Fortbildungen",
      otherAbsenceDays: "Sonstige Fehltage (Kur, Spital, Sonderurlaub)",
      actualWorkdays: "Anzahl meiner tatsächlichen Arbeitstage",
      actualWorkdaysHint: "Urlaube, Fortbildungen und sonstige geplante Fehltage bereits selbst abziehen.",
      target1bPerWeek: "Vorgabe 1B / Woche",
      targetEgPerWeek: "Vorgabe EG / Woche",
    },
    workModels: {
      fiveDays: "Vollzeit / Teilzeit · 5 Tage-Woche",
      fourDays: "Teilzeit · 4 Tage-Woche",
      threeDays: "Teilzeit · 3 Tage-Woche",
      twoDays: "Teilzeit · 2 Tage-Woche",
      oneDay: "Teilzeit · 1 Tag-Woche",
    },
    result: {
      effectiveWorkdays: "Effektive Arbeitstage",
      workdaysPerWeek: "÷ Arbeitstage / Woche",
      weeksPerMonth: "= Wochen im Monat",
      hoursFactor: "× Stundenfaktor ({{hours}}/{{base}})",
      appointmentsLabel: "Einzugebende Termine",
      target1b: "1B / Monat",
      targetEg: "EG / Monat",
      footnote:
        "Vollzeit-Basis {{base}} Std./Woche · Vorgabe {{target1b}} 1B & {{targetEg}} EG je volle Woche · kaufmännisch gerundet (genau: {{exact1b}} 1B / {{exactEg}} EG)",
      empty: "Geben Sie Ihre Arbeitstage und Wochenstunden ein, um die Berechnung zu sehen.",
    },
  },
};

export default calculators;
